export enum OrganizationUserDetailsTabTypes {
    DETAILS = "details",
    ADMIN_API_ACCESS = "admin-api-access",
    PERMISSIONS_PANEL = "permissions-panel",
    USER_ACTIVITY = "user-activity"
}